module.exports = __webpack_public_path__ + "img/ic_followup_client.f034dd58.svg";